import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { EnvironmentConfiguration } from '../environment/services/environment.configuration';

@Injectable({ providedIn: 'root' })
export class ManualUploadProcStatusService {

  constructor(private http: HttpClient, private environment: EnvironmentConfiguration) {}

  private get s9BaseUrl(): string { return this.environment.commonS9RestUrl; }

  private getHttpOptions() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': localStorage.getItem('Ebom_accessToken') || '',
        'x-api-key': localStorage.getItem('Filename') || ''
      })
    };
  }

  getUploadProcStatusList(uploadType: string | null, uploadStatus: string | null): Observable<any> {
    const fileName   = localStorage.getItem('Filename') || '';
    const typeParam  = uploadType   ? `&uploadType=${uploadType}`     : '';
    const statusParam = uploadStatus ? `&uploadStatus=${uploadStatus}` : '';
    const url = `${this.s9BaseUrl}/getManualUploadProcStatus/list?screenNo=NBPC_10117&fileName=${fileName}${typeParam}${statusParam}`;
    return this.http.get(url, this.getHttpOptions()).pipe(map((res: any) => res));
  }

  updateUploadProcStatus(uploadId: number, uploadStatus: string, remarks: string): Observable<any> {
    const fileName  = localStorage.getItem('Filename') || '';
    const updatedBy = localStorage.getItem('emailId') || '';
    const body = { upload_id: uploadId, upload_status: uploadStatus, remarks, updated_by: updatedBy,
                   screenNo: 'NBPC_10117', fileName };
    const url = `${this.s9BaseUrl}/updateManualUploadProcStatus/update?screenNo=NBPC_10117&fileName=${fileName}`;
    return this.http.put(url, body, this.getHttpOptions()).pipe(map((res: any) => res));
  }
}
